import { CredifyClass } from "./common";
import { camelize, decamelize, validateFiatCurrencyObject } from "./utils";
import { MarketplaceApiFactory } from "@credify/api-docs/apiClients/integration-v2/api";
import { LodgingRequest } from "@credify/api-docs/apiClients/integration-v2/model";
import { handleAPIConfiguration } from "./utils";

export class Intent extends CredifyClass {
  /**
   * Complete the bnpl order
   * @param request - LodgingRequest
   * @returns Promise<any>
   */
  public async lodgeNewIntent(request: LodgingRequest): Promise<any> {
    const backupClaims = request.user?.claims;
    request = camelize(request);
    if (backupClaims) {
      //@ts-ignore
      request.user?.claims = backupClaims;
    }

    for (const o of request.bnplOrder?.orderLines || []) {
      if (o.unitPrice) {
        o.unitPrice = validateFiatCurrencyObject(o.unitPrice);
      }
      if (o.subtotal) {
        o.subtotal = validateFiatCurrencyObject(o.subtotal);
      }
    }

    if (request.bnplOrder?.totalAmount) {
      request.bnplOrder.totalAmount = validateFiatCurrencyObject(
        request.bnplOrder.totalAmount
      );
    }

    try {
      const configuration = handleAPIConfiguration(this.config.mode);
      const client = MarketplaceApiFactory(
        configuration,
        "",
        this.apiClient.instance as any
      );
      const res = await client.lodgeNewIntent(request);

      if (!res.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      //console.log(error);
      throw error;
    }
  }
}
